package org.zest.insan_360_website.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.forms.Input
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.common.PlaceholderColor
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.onSubmit
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Form
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.Text
import org.zest.insan_360_website.data.page_states.ForgotPasswordPageState
import org.zest.insan_360_website.components.layouts.*
import org.zest.insan_360_website.components.widgets.DotLoading
import org.zest.insan_360_website.components.widgets.LocalToast
import org.zest.insan_360_website.data.LanguageSettings
import org.zest.insan_360_website.data.localized
import org.zest.insan_360_website.model.ForgotPasswordRequest
import org.zest.insan_360_website.utils.NetworkUtils
import org.zest.insan_360_website.utils.processResponse

@Page("/forgot-password")
@Layout(".components.layouts.MainPageLayout")
@Composable
fun ForgotPasswordPage() {
    val state = ForgotPasswordPageState.state
    
    val toast = LocalToast.current
    val scope = rememberCoroutineScope()
    val authWordLibrary = LanguageSettings.AuthenticationPage
    
    val submitForm: () -> Unit = {
        if (state.email.isBlank() || !state.email.contains("@")) {
            toast.show(authWordLibrary.enterValidEmail.localized)
        } else {
            ForgotPasswordPageState.state = state.copy(isProcessing = true)
            scope.launch {
                try {
                    val response = NetworkUtils.postBasicApi(
                        "/api/auth/forgot-password", 
                        ForgotPasswordRequest(state.email)
                    )
                    processResponse<Unit>(
                        response = response,
                        toast = toast,
                        fallbackErrorLog = "Failed to request password reset"
                    ) {
                        ForgotPasswordPageState.state = state.copy(isSent = true)
                    }
                } catch (_: Exception) {
                    toast.show(LanguageSettings.General.networkFailure.localized)
                } finally {
                    ForgotPasswordPageState.state = state.copy(isProcessing = false)
                }
            }
        }
    }

    StandaloneFormContainer {
        Column(
            Modifier
                .backgroundColor(Colors.White)
                .fillMaxSize()
                .padding(2.cssRem)
                .gap(1.cssRem),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Center
        ) {
            H2(
                Modifier
                    .textAlign(TextAlign.Center)
                    .margin(0.px)
                    .toAttrs()
            ) { 
                Text(authWordLibrary.forgotPassword.localized) 
            }

            if (state.isSent) {
                SpanText(
                    authWordLibrary.resetEmailSent.localized,
                    Modifier.textAlign(TextAlign.Center).fontSize(1.cssRem)
                )
                A(
                    attrs = Modifier
                        .fontSize(0.75.cssRem)
                        .color(darkGreenColor)
                        .margin(top = 1.cssRem)
                        .toAttrs(),
                    href = "/"
                ) {
                    Text(authWordLibrary.backToLogin.localized)
                }
            } else {
                Form(
                    attrs = Modifier.fillMaxWidth().toAttrs {
                        onSubmit {
                            it.preventDefault()
                            submitForm()
                        }
                    }
                ) {
                    Column(Modifier.fillMaxWidth().gap(1.cssRem)) {
                        Input(
                            modifier = baseInputStyle.toModifier().attrsModifier {
                                attr("autocomplete", "email")
                                attr("name", "email")
                            },
                            focusBorderColor = lightGreenColor,
                            placeholderColor = PlaceholderColor(lightGreenColor),
                            type = InputType.Email,
                            value = state.email,
                            onValueChange = { ForgotPasswordPageState.state = state.copy(email = it) },
                            placeholder = authWordLibrary.email.localized
                        )
                        Button(
                            enabled = !state.isProcessing,
                            onClick = { submitForm() },
                            modifier = buttonColorStyle.toModifier()
                                .fillMaxWidth()
                        ) {
                            if (state.isProcessing) {
                                DotLoading(Colors.White)
                            } else {
                                SpanText(
                                    authWordLibrary.sendResetLink.localized,
                                    contentButtonTextStyle.toModifier().fontSize(1.cssRem)
                                )
                            }
                        }
                    }
                }
                A(
                    attrs = Modifier
                        .fontSize(0.75.cssRem)
                        .color(darkGreenColor)
                        .toAttrs(),
                    href = "/"
                ) {
                    Text(authWordLibrary.backToLogin.localized)
                }
            }
        }
    }
}
